export const multiSelectFilter = 'multiSelectFilter';
